module.exports = __webpack_public_path__ + "img/1.787e274a.png";